import React, { useState, useEffect } from "react";
import videosData from "../mock/videos";
import {
  VideoCameraBackOutlined,
  PlayCircleOutline,
} from "@mui/icons-material";

const VideosSection = () => {
  const [showAll, setShowAll] = useState(false);
  const [playingVideoIds, setPlayingVideoIds] = useState([]);

  const handlePlay = (id) => {
    setPlayingVideoIds((prev) => [...prev, id]);
  };

  const videosToShow = showAll ? videosData : videosData.slice(0, 6);

  return (
    <section id="videos" className="scroll-mt-24 py-12">
      <div className="container mx-auto px-4">
        {/* Título */}
        <div className="text-center lg:mb-8 mb-2 px-[5%]">
          <h2
            className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-pink-500 to-red-600 tracking-wide flex items-center justify-center gap-2"
            data-aos="zoom-in-up"
          >
            <VideoCameraBackOutlined
              className="text-yellow-400 animate-spin"
              fontSize="large"
            />
            Explora China en Movimiento
            <VideoCameraBackOutlined
              className="text-yellow-400 animate-spin"
              fontSize="large"
            />
          </h2>
          <p
            className="mt-4 text-white max-w-3xl mx-auto text-base sm:text-lg font-medium italic leading-relaxed"
            data-aos="fade-up"
          >
            Sumérgete en la magia de nuestros viajes a través de estos videos.
          </p>
        </div>

        {/* Tarjetas */}
        <div
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
          data-aos="fade-up"
        >
          {videosToShow.map((video) => {
            const isPlaying = playingVideoIds.includes(video.id);
            return (
              <div
                key={video.id}
                className="bg-white rounded-xl overflow-hidden shadow-lg transition-transform duration-500 ease-in-out transform hover:scale-105 hover:brightness-105 hover:shadow-2xl"
              >
                <div className="relative w-full h-64 bg-black">
                  {!isPlaying ? (
                    <div
                      className="w-full h-full flex items-center justify-center cursor-pointer relative group"
                      onClick={() => handlePlay(video.id)}
                    >
                      <img
                        src={video.thumbnail}
                        alt="Video thumbnail"
                        className="absolute w-full h-full object-cover"
                      />
                      <div className="z-10 bg-black bg-opacity-50 p-4 rounded-full transition group-hover:scale-110">
                        <PlayCircleOutline
                          fontSize="large"
                          className="text-white"
                        />
                      </div>
                    </div>
                  ) : (
                    <iframe
                      src={video.url}
                      title={video.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      className="w-full h-full"
                    />
                  )}
                </div>

                <div className="p-6">
                  <h3 className="text-xl font-bold mb-2 text-gray-800">
                    {video.title}
                  </h3>
                  <p className="text-gray-600">{video.description}</p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Botón mostrar más */}
        {videosData.length > 6 && (
          <div className="text-center mt-8">
            <button
              onClick={() => setShowAll(!showAll)}
              className="bg-gradient-to-r from-indigo-500 to-purple-500 text-white px-6 py-2 rounded-full shadow-md hover:shadow-lg transition"
            >
              {showAll ? "Mostrar menos" : "Mostrar más"}
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default VideosSection;
